import { Flex, Loader } from '@fluentui/react-northstar';

// renders a full Screen loader with lable in center of the page
const FullScreenLoader = ({ label }: { label: string }) => {
  return (
    <Flex fill hAlign="center" vAlign="center">
      <Loader label={label} />
    </Flex>
  );
};

export default FullScreenLoader;
